import PropTypes from 'prop-types';

import Icon from '../Icon/Icon';

import { getIconClass } from '../Icon/Icon.constants';

function ButtonIcon({ icon, iconStyle, height, role, invert, width, onClick, style }) {
  const iconButtonClass = getIconClass({
    icon,
    invert,
    style,
  });
  return (
    <button onClick={onClick} role={role} className={iconButtonClass}>
      <Icon name={icon} className={iconStyle} width={width} height={height} />
    </button>
  );
}

ButtonIcon.propTypes = {
  // only for DD
  hasIconBorder: PropTypes.bool,
  // icon's height
  height: PropTypes.number,
  icon: PropTypes.string.isRequired,
  // icon's classname
  iconStyle: PropTypes.string,
  invert: PropTypes.bool,
  onClick: PropTypes.func,
  role: PropTypes.string,
  // button's classname
  style: PropTypes.string,
  // icon's width
  width: PropTypes.number,
};

ButtonIcon.defaultProps = {
  icon: '',
  iconStyle: '',
  invert: false,
  role: 'button',
  style: '',
  hasIconBorder: false,
};

export default ButtonIcon;
